import Vue from 'vue';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import router from './router';
import store from './store/index';
import apolloProvider from './plugins/vue-apollo';

import './plugins/bootstrap';
import './plugins/element-ui';
import './plugins/font-awesome';
import './plugins/simplebar';

// global components import
import AppSubHeader from './components/AppSubHeader.vue';
import AppFocusLock from '@/components/AppFocusLock.vue';

import toUSD from './filters/toUSD';
import toUSD2 from './filters/toUSD2';
import toReverse from './filters/toReverse';

Vue.prototype.$windowObj = window;

Vue.use(VueGtag, {
  config: {
    id: 'G-BNGK5C3XG6',
    params: {
      page_path: window.location.pathname + window.location.hash,
    },
  },
});


Vue.filter('toUSD', toUSD);
Vue.filter('toUSD2', toUSD2);
Vue.filter('toReverse', toReverse);


// global components declare
Vue.component('app-sub-header', AppSubHeader);
Vue.component('app-focus-lock', AppFocusLock);

Vue.config.productionTip = false;

new Vue({
  apolloProvider,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
